var AnnouncementType = {
  ALL: -1,
  ANNOUNCEMENT: 1,
  PAYMENT: 2,
  GAMES: 3,
  PROMOTION: 4
}

export { AnnouncementType }
